import { api } from '../../app/api.js';
import { display_errors } from '../../helpers/forms.js';

export default {
    template: `    
        <div class="background turntable"></div>
        <div id="Checkout" class="flexy-column">
            <div id="Login" class="container">
                <h1>Checkout</h1>
                
                <div class="columns no-marg separator">
                    <div class="guest">
                        <h3>Guest Checkout</h3>
                        <p>
                            Checkout without creating an account.<br/>
                            You can create an account after checkout.
                        </p>
                        <button id="GuestSelection" class="fw">Guest</button>
                    </div>
                    <form id="login-form" class="form">
                        <div class="input">
                            <label for="LoginEmailAddress">Email Address</label>
                            <input type="text" id="LoginEmailAddress"  name="email"/>
                        </div>
            
                        <div class="input">
                            <label for="LoginPassword">Password</label>
                            <input type="password" id="LoginPassword" name="password"/>
                        </div>
            
                        <button id="LoginSubmit" type="submit">Log In</button>
                        <div id="LoginErrors" class="errors hidden"></div>
                        
                        <div class="input">
                            <input type="checkbox" id="LoginRemember" name="remember"/>
                            <label for="LoginRemember">Remember me</label>
                        </div>
                    </form>
                </div>
            </div>
            <div id="Guest" class="container hidden">
                <h1>Your Details</h1>
    
                <form id="GuestForm" class="form">
                    <div class="input">
                        <label for="GuestEmail">Email Address</label>
                        <input type="email" id="GuestEmail">
                    </div>
    
                    <div class="input">
                        <label for="GuestFirstName">First Name</label>
                        <input type="text" id="GuestFirstName">
                    </div>
    
                    <div class="input">
                        <label for="GuestLastName">Last Name</label>
                        <input type="text" id="GuestLastName">
                    </div>
                    
                    <div class="input">
                        <input type="checkbox" id="GuestTermsAgreement" name="terms_agreement" required/>
                        <label for="GuestTermsAgreement">I have read and agree to the <a href="/terms" target="_blank">terms of service</a>.</label>
                    </div>
    
                    <div class="input">
                        <input type="checkbox" id="GuestMarketingConsent"/>
                        <label for="GuestMarketingConsent">I would like to receive marketing and promotional emails</label>
                    </div>
    
                    <div class="submit">
                        <input id="GuestSubmit" type="submit" value="Next">
                    </div>
    
                    <div id="GuestErrors" class="errors hidden"></div>
                </form>
            </div>
            <div id="Payment" class="container hidden">
                <h1>Payment</h1>
    
                <table style="margin-bottom: 10px;">
                    <thead>
                        <tr>
                            <th class="left">Products</th>
                            <th>Price</th>
                        </tr>
                    </thead>
                    <tbody class="OrderProducts">
                    </tbody>
                    <tfoot>
                        <tr>
                            <th class="right">Total</th>
                            <th class="right OrderTotal">---</th>
                        </tr>
                    </tfoot>
                </table>
    
                <!-- Apple Pay / Google Pay -->
                <div id="payment-request-button"></div>
    
                <!-- Divider -->
                <div id="or-divider" class="hidden" style="text-align:center; margin: 1em 0;">or pay with card</div>
    
                <!-- Card form -->
                <form id="payment-form" class="form">
    
                    <div class="input">
                        <label for="CardholderName">Cardholder's Name</label>
                        <input type="text" id="CardholderName" autocomplete="off"/>
                    </div>
    
                    <div class="input">
                        <span class="label">Payment Card</span>
                        <div id="card-element" class="stripe-element"></div>
                    </div>
                    
                    <button id="PaymentSubmit" type="submit">Pay <span class="OrderTotal"></span></button>
                    <div id="PaymentErrors" class="errors hidden"></div>
                </form>
            </div>
            <div id="Complete" class="container hidden">
                <h1>Payment Successful</h1>
                
                <p>Your payment has been processed successfully. Thank you for your support.</p>
            </div>
        </div>
    `,

    $guest_form: null,
    $guest_selection_button: null,
    $guest_submit: null,
    $guest_errors: null,

    order_id: null,
    order_key: null,
    cardholder_name: null,
    email_address: null,

    async onMount() {
        this.$guest_selection_button = document.getElementById('GuestSelection');
        this.$guest_form = document.getElementById('GuestForm');
        this.$guest_submit = document.getElementById('GuestSubmit');
        this.$guest_errors = document.getElementById('GuestErrors');
        // TODO: Terms Link - Open in new tab

        this.current_step = 0;
        this.authenticated = false;
        this.steps = ['Login', 'Guest', 'Payment', 'Complete'];

        this._guest_selection = () => {
            this.current_step = 1;
            this.update_step(0);
        }
        this.$guest_selection_button.addEventListener('click', this._guest_selection);

        this._guest_submit = () => {
            this.$guest_submit.value = 'Processing...';
            this.$guest_submit.disabled = true;

            this.create_order();
        }

        this.$guest_form.addEventListener('submit', this._guest_submit);
    },
    onUnmount() {
        if (this._guest_selection && this.$guest_selection_button) {
            this.$guest_selection_button.removeEventListener('submit', this._guest_selection);
        }

        if (this._guest_submit && this.$guest_form) {
            this.$guest_form.removeEventListener('submit', this._guest_submit);
        }
    },
    update_step(last_step = null) {
        if (last_step !== null) {
            document.getElementById(this.steps[last_step]).classList.add('hidden');
        } else {
            this.steps.forEach(step => {
                document.getElementById(step).classList.add('hidden');
            });
        }

        document.getElementById(this.steps[this.current_step]).classList.remove('hidden');
    },
    create_order() {
        let payload = {};

        if (!this.authenticated) {
            payload['email'] = document.getElementById('GuestEmail').value;
            payload['first_name'] = document.getElementById('GuestFirstName').value;
            payload['last_name'] = document.getElementById('GuestLastName').value;
            payload['terms_agreement'] = document.getElementById('GuestTermsAgreement').checked;
            payload['marketing_consent'] = document.getElementById('GuestMarketingConsent').checked;
        }

        // Load Basket Items
        payload['product_ids'] = [1]

        api.post({
            url: '/order/create/',
            method: 'POST',
            data: payload,
            success: response => {
                this.order_id = response.order_id;
                this.order_key = response.key;
                this.cardholder_name = `${response.first_name} ${response.last_name}`;
                this.email_address = response.email_address;

            }, error: response => {
                if (!this.authenticated) {
                    display_errors(this.$guest_errors, response, this.$guest_form);
                    this.$guest_submit.value = 'Next';
                    this.$guest_submit.disabled = false;
                }
            }
        })
    }
};
